import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  powerSupply: [number, string],
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (powerSupply, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      powerSupply,
    },
  });
};

export const PowerSupply = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    powerSupply: powerSupplyAddonProducts,
    custom: { powerSupply },
  } = state.context;
  const addOnProduct =
    Array.isArray(powerSupply) &&
    powerSupplyAddonProducts.find(
      ({ first_available_variant: { id } }) => id === powerSupply[0],
    );
  const showCableSide =
    addOnProduct && addOnProduct.title.toLowerCase().includes('240');

  if (
    isCurrentState('powerSupply', state) &&
    powerSupplyAddonProducts.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Power supply</Heading>
      <Selector>
        {powerSupplyAddonProducts.map(product => {
          const {
            title,
            first_available_variant: { id },
          } = product;
          const isSelected =
            Array.isArray(powerSupply) && powerSupply[0] === id;
          const secondValue = product.title.toLowerCase().includes('240')
            ? 'left'
            : '';
          return (
            <SelectorItem
              isSelected={isSelected}
              key={id}
              onClick={onClick([id, secondValue], send)}
            >
              {title}
            </SelectorItem>
          );
        })}
      </Selector>
      {showCableSide && (
        <>
          <Heading>Cable side</Heading>
          <Selector>
            {['left', 'right'].map(option => {
              const isSelected =
                Array.isArray(powerSupply) && powerSupply[1] === option;
              return (
                <SelectorItem
                  noCol={2}
                  key={option}
                  isSelected={isSelected}
                  onClick={onClick([powerSupply[0], option], send)}
                >
                  {option}
                </SelectorItem>
              );
            })}
          </Selector>
        </>
      )}
    </SectionContent>
  );
};
